import { AppModules } from 'appContainer/types';
import {
  sortingParam,
  uriComponentParam,
} from 'router/declarative/paramRegistry';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { OrgTabs } from './types';

export const routes = {
  path: '/manage-organization',
  appModule: AppModules.MANAGE_ORGANIZATION,
  content: async (): IndexRouteContent =>
    (await import('../../appContainer/ManageOrganizationContainer'))
      .ManageOrganizationContainer,
  children: [
    { path: { index: true } },
    { path: `/${OrgTabs.SETTINGS}` },
    { path: `/${OrgTabs.FEATURE_SETTINGS}` },
    { path: `/${OrgTabs.MIGRATION_CHECKLIST}` },
    {
      path: `/${OrgTabs.WEBHOOKS}`,
      content: async (): PathRouteContent =>
        (await import('../orgSettings/WebhookManagementV2'))
          .WebhookManagementV2,
    },
    { path: `/${OrgTabs.BUNDLES}` },
    { path: `/${OrgTabs.ENTITY_GROUPS}` },
    {
      path: `/${OrgTabs.ENTITY_GROUPS_V2}`,
      searchParams: { query: uriComponentParam },
      content: async (): PathRouteContent =>
        (
          await import('../entityGroup/EntityGroupManagementV2/EntityGroupManagementV2Page')
        ).EntityGroupManagementV2Page,
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (
              await import('../entityGroup/EntityGroupManagementV2/EntityGroupManagementV2Overview')
            ).EntityGroupManagementV2Overview,
        },
        {
          path: '/create',
          content: async (): PathRouteContent =>
            (
              await import('../entityGroup/EntityGroupManagementV2/EntityGroupManagementV2')
            ).EntityGroupManagementV2,
        },
        {
          path: '/:entityId',
          content: async (): PathRouteContent =>
            (
              await import('../entityGroup/EntityGroupManagementV2/EntityGroupManagementV2')
            ).EntityGroupManagementV2,
        },
      ],
    },
    { path: `/${OrgTabs.USE_CASES}` },
    {
      path: `/${OrgTabs.WORKSPACE_OVERVIEW}`,
      searchParams: { query: uriComponentParam, sorting: sortingParam },
    },
    { path: `/${OrgTabs.DISCOVER_SETTINGS}` },
    {
      path: `/${OrgTabs.BRANDING}`,
      content: async (): PathRouteContent =>
        (await import('../brandingSettings/BrandingSettings')).BrandingSettings,
    },
    {
      path: `/${OrgTabs.COMPONENT_OVERVIEW}`,
      content: async (): PathRouteContent =>
        (
          await import('../componentOverviewCustomization/ComponentOverviewCustomizationContainer')
        ).ComponentOverviewCustomizationContainer,
      children: [
        {
          path: '/:componentTypeName',
          content: async (): PathRouteContent =>
            (
              await import('../componentOverviewCustomization/ComponentOverviewCustomizationContainer')
            ).ComponentOverviewCustomizationContainer,
        },
      ],
    },
    { path: `/${OrgTabs.SUBSCRIPTION}` },
    { path: `/${OrgTabs.DOCUMENT_ARCHIVE}` },
    { path: `/${OrgTabs.GRAPH_FILTERS}` },
    { path: `/${OrgTabs.HOME_SETTINGS}` },
    { path: `/${OrgTabs.SEARCH_SETTINGS}` },
    { path: `/${OrgTabs.SYSTEM_OVERVIEW}` },
    { path: `/${OrgTabs.AI_SETTINGS}` },
    { path: `/${OrgTabs.ARDOQ_CATALOG}` },
    { path: `/${OrgTabs.TRANSFORMATIONS}` },
    {
      path: `/${OrgTabs.TIME_TRAVEL}`,
      content: async (): PathRouteContent =>
        (await import('../timeTravel/TimeTravelManagementPage'))
          .TimeTravelManagementPage,
    },
  ],
} as const satisfies RouteNode;
